import React from "react";
import { Box, Paper } from "@mui/material";
import CustomText from "../CustomText";
import { useMediaQuery,} from "@mui/material";
import { useTheme } from "@mui/material/styles";
const AccessibleCard = ({
  icon,
  title,
  description,
  variant = "light", // 'light' or 'dark'
  sx,
 titleVariant = "h4",
 descriptionStyle,
}) => {
        const theme = useTheme();
  const isLight = variant === "light";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // e.g. below 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg")); 
  return (
    <Paper
      elevation={0}
      sx={{
     
        borderRadius: "2px",
        backgroundColor: isLight ? "white" : "#002A3F",
       borderBottom: "1px solid #DFDFDF", 
  borderLeft: "1px solid #D1D3D9",         
  borderRight: "1px solid #D1D3D9",
  borderTop: "none",                         
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: "4px",
  borderBottomRightRadius: "4px",
        boxShadow: isLight
          ? "0px 4px 25px 0px rgba(141, 141, 141, 0.05)"
          : "0px 4px 25px 0px rgba(0, 0, 0, 0.05)",
        ...sx,
      }}
    >
      {/* <Box sx={{ mb: 3, mt:1,border:"1.8px solid #D1D3D9",borderRadius:"10px", padding:"8px 6px 6px 6px",width:isMobile?"20%":"20%"}}>
        {icon}</Box> */}
   <Box
        sx={{
          mb: 3,
        //   mt: 1,
        //   borderRadius: "10px",
          width: "100%",
        //   height: "100%",
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {icon}
      </Box>
      <Box sx={{   px: 2,
        py:0,pb:3}}>
      <CustomText
         variant={titleVariant} 
        customStyle={{
          fontSize: "24px",
          fontWeight: 600,
          fontFamily: "Poppins, sans-serif",
          color: isLight ? "#363333" : "white",
          textAlign: "left",
          marginBottom: "20px",
          lineHeight:"1.3",
      
        }}
      >
        {title}
      </CustomText>
      <CustomText
        style={{
          fontSize: "16px",
          fontWeight: 400,
          fontFamily: "Nunito, sans-serif",
          color: isLight ? "#868282" : "#E5E5E5",
          textAlign: "left",
          marginTop:"13px",
          lineHeight: "170%",
          ...descriptionStyle,
        }}
      >
        {description}
      </CustomText>
      </Box>
    </Paper>
  );
};

export default AccessibleCard;